import axios from "axios";

export const getPreciosService = async (producto_id) => {
    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/get-precios/${producto_id}`);
    return data;
}

export const getPrecioService = async (id) => {
    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/get-precio/${id}`);
    return data;
}

export const storePrecioService = async (obj) => {
    const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/store-precio`, obj);
    return data;
}

export const updatePrecioService = async (obj, id) => {
    const { data } = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/update-precio/${id}`, obj);
    return data;
}

export const deletePrecioService = async (id) => {
    const { data } = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/delete-precio/${id}`);
    return data;
}
